import { useEffect, useState } from 'react';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { User, useUser_GetAllDitDeniedUsersQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import ClientDitApproval from './client-dit-approval';

const useStyles = makeStyles((theme) => ({
  taskContainer: {
    marginTop: '12px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      height: '282px',
    },
    background: '#FFFFFF',
    justifyContent: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
  },
  listContainer: {
    [theme.breakpoints.up('sm')]: {
      height: '475px',
    },
    overflow: 'auto',
  },
  listItem: {
    width: '95%',
    margin: 'auto',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
  },
  taskTitle: { display: 'flex' },
  title: {
    fontWeight: 600,
  },
  container: {
    width: '100%',
  },
}));

export default function ClientActivity() {
  const classes = useStyles();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [list, setList] = useState<any>();
  const [count, setCount] = useState<number>(0);

  const { data: allDitDeniedUsers } = useUser_GetAllDitDeniedUsersQuery({
    onError: (e) => {
      showAlert({
        message: 'Error getting all dit denied users: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  const handleRemoveUser = (id: string) => {
    const newList = list.filter((user: User) => user.id !== id);
    setCount(1);
    setList(newList);
  };

  useEffect(() => {
    if (count === 0) {
      setList(allDitDeniedUsers?.data);
    }
  }, [count, allDitDeniedUsers?.data]);

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h5">
        Client Activity
      </Typography>
      <div className={classes.taskContainer}>
        <List className={classes.listContainer}>
          {list?.map((user: User) => (
            <ClientDitApproval
              key={user.id}
              id={user.id}
              avatarUrl={user.avatarUrl}
              name={`${user.firstName} ${user.lastName}`}
              status={`${user.efxDigitalIdentityTrust}`}
              handleListSave={handleRemoveUser}
            />
          ))}
          {list?.length === 0 ? (
            <ListItem className={classes.listItem}>
              <Grid container>
                <Grid item xl={12} xs={12} className={classes.taskTitle}>
                  <Typography>no items</Typography>
                </Grid>
              </Grid>
            </ListItem>
          ) : (
            ''
          )}
        </List>
      </div>
    </div>
  );
}
